import { useCallback, useEffect, useState } from 'react';

import { isValidEmail } from 'utilities/Validators';

const useForgotPasswordFormState = ({ onErrorClear }) => {
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotFormValid, setForgotFormValid] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  useEffect(() => {
    setForgotFormValid(forgotEmail.length > 0 && isValidEmail(forgotEmail));
  }, [forgotEmail]);

  const handleForgotEmailChange = useCallback((value) => {
    setForgotEmail(value);
    setForgotSent(false);
    onErrorClear && onErrorClear();
  }, [onErrorClear]);

  const resetForgotForm = useCallback(() => {
    setForgotEmail('');
    setForgotFormValid(false);
    setForgotSent(false);
  }, []);

  const markForgotSent = useCallback(() => {
    setForgotSent(true);
  }, []);

  const seedForgotEmail = useCallback((email) => {
    setForgotEmail(String(email || '').trim().toLowerCase());
    setForgotSent(false);
    onErrorClear && onErrorClear();
  }, [onErrorClear]);

  return {
    forgotEmail,
    forgotFormValid,
    forgotSent,
    handleForgotEmailChange,
    resetForgotForm,
    markForgotSent,
    seedForgotEmail,
  };
};

export default useForgotPasswordFormState;
